import { atom } from "jotai";

export const backgroundTranslation = atom("0% 0%");

export const shouldLoadPage = atom(true);
